import React from 'react';
import OLYWebPageComponent from '../components/OLYWebPageComponent';
import DynIcon from '../components/Utils/DynIcon';
import { translate } from 'react-i18next';
import { LinearProgress } from 'material-ui';
import { Typography } from 'material-ui';
import { Grid } from 'material-ui';
import { withStyles } from 'material-ui';
import { getCMSWidgetComponentByObject, getCMSConfiguration, getCMSSectionContent, cmsChildHandler } from './cmsLib';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    }
});
class Landing extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            hotels: [],
            content: {
                central_text: '',
                image_text: ''
            }
        };
        this.pageName = 'LANDING';
        this.cmsConfiguration = getCMSConfiguration();
    }

    onHashChanged = hash => {
        let parent, order = 1;
        try {
            let keys = hash.parts[1].split(',');
            parent = parseInt(keys[0]);
            order = parseInt(keys[1]);
        } catch (error) {
            parent = order = 1;
        }
        this.getAsyncConfiguration(parent, order);
    }

    async getAsyncConfiguration(parent, order) {
        parent = Math.max(0, parent);
        let thehotels = [];
        let json = { content: {} };
        try {
            json = await getCMSSectionContent('openlandingaction', parent, order);
            json = json[0];
            if (json.hotels) {
                json.hotels.map(h => {
                    let props = { ...h };
                    h.type = 'HotelBook';
                    h.action = { type: 'SearchAvailability' };
                    h.action.hotelAvailabilityRequest = props;
                });
            } else {
                json.hotels = [];
            }
            thehotels = json.hotels;
            cmsChildHandler(this.pageName, json);
        } catch (error) {
            thehotels = [];
            json = {
                content: {
                    central_text: '',
                    image_text: ''
                }
            };
            alert(error.message);
        }
        this.setState({
            hotels: thehotels,
            content: json.content,
            loading: false,
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="cmsLanding">
                <div className="cmsContainer">
                    <div style={{ margin: '5px' }}>
                        {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    </div>
                    <div style={{ padding: 8 }}>
                        <Grid container justify="center">
                            <Grid item xs>
                                <Typography className="newsPaper" dangerouslySetInnerHTML={{ __html: this.state.content.central_text }}></Typography>
                            </Grid>
                        </Grid>
                    </div>
                    <div style={{ padding: 8 }}>
                        <Grid container>
                            {
                                this.state.hotels.map(hotel => {
                                    return <Grid item xs={4} key={hotel.code}>
                                        {getCMSWidgetComponentByObject(hotel)}
                                    </Grid>;
                                })
                            }
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(Landing));


// WEBPACK FOOTER //
// ./src/cms/Landing.js